<template>
  <v-container fluid pa-5>
    <v-form ref="SettingsForm" v-model="isFormValid" lazy-validation>
      <v-card class="mt-4 mb-4">
        <v-card-text>
          <v-tabs v-model="tab" :vertical="!isSmallDisplay">
            <v-tab :key="DASHBOARD" class="px-0 pl-3 pr-6">
              <div style="width: 15%">
                <v-icon>speed</v-icon>
              </div>
              <div style="width: 85%" class="pl-3 text-left">
                Dashboard
              </div>
            </v-tab>
            <v-tab :key="DEALS" class="px-0 pl-3 pr-6">
              <div style="width: 15%">
                <v-icon>handshake</v-icon>
              </div>
              <div style="width: 85%" class="pl-3 text-left">
                Deals
              </div>
            </v-tab>
            <v-tab :key="EMAIL_SERVER" class="px-0 pl-3 pr-6">
              <div style="width: 15%">
                <v-icon>email</v-icon>
              </div>
              <div style="width: 85%" class="pl-3 text-left">
                Email Server
              </div>
            </v-tab>
            <v-tab :key="HEADCOUNT" class="px-0 pl-3 pr-6">
              <div style="width: 15%">
                <v-icon>group</v-icon>
              </div>
              <div style="width: 85%" class="pl-3 text-left">
                Headcount
              </div>
            </v-tab>
            <v-tab :key="PAY_RATE" class="px-0 pl-3 pr-6">
              <div style="width: 15%">
                <v-icon>payments</v-icon>
              </div>
              <div style="width: 85%" class="pl-3 text-left">
                Pay Rate
              </div>
            </v-tab>
            <v-tab :key="SCHEDULED_JOBS" class="px-0 pl-3 pr-6">
              <div style="width: 15%">
                <v-icon>schedule</v-icon>
              </div>
              <div style="width: 85%" class="pl-3 text-left">
                Scheduled Jobs
              </div>
            </v-tab>
            <v-tab :key="SYSTEM" class="px-0 pl-3 pr-6">
              <div style="width: 15%">
                <v-icon>build</v-icon>
              </div>
              <div style="width: 85%" class="pl-3 text-left">
                System
              </div>
            </v-tab>
            <v-tab :key="ZOHO_INTEGRATION" class="px-0 pl-3 pr-6">
              <div style="width: 15%">
                <v-icon>cable</v-icon>
              </div>
              <div style="width: 85%" class="pl-3 text-left">
                Zoho
              </div>
            </v-tab>
            <v-tab-item :key="DASHBOARD" class="ml-md-10" style="max-height: 650px; min-height: 650px; overflow: auto; overflow-x: hidden;">
              <v-row class="mt-5 ml-3">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="2" xl="1">
                      <v-card-text class="py-0 px-0">Gross Profit</v-card-text>
                    </v-col>
                    <v-col col="12" sm="9" md="8" lg="6" xl="3" class="py-0">
                      <SecurityRolesDropDownList
                        :securityRoles="dashboardSettings.grossProfit"
                        :multiple="true"
                        :isRequired="true"
                        @securityRolesChange="(newValue) => this.dashboardSettings.grossProfit = newValue"
                      ></SecurityRolesDropDownList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="mt-5 ml-3">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="2" xl="1">
                      <v-card-text class="py-0 px-0">Headcount</v-card-text>
                    </v-col>
                    <v-col col="12" sm="9" md="8" lg="6" xl="3" class="py-0">
                      <SecurityRolesDropDownList
                        :securityRoles="dashboardSettings.headCount"
                        :multiple="true"
                        :isRequired="true"
                        @securityRolesChange="(newValue) => this.dashboardSettings.headCount = newValue"
                      ></SecurityRolesDropDownList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ml-3" v-if="zohoIntegrationSettings.integrationEnabled">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="2" xl="1">
                      <v-card-text class="py-0 px-0">Interviews</v-card-text>
                    </v-col>
                    <v-col col="12" sm="9" md="8" lg="6" xl="3" class="py-0">
                      <SecurityRolesDropDownList
                        :securityRoles="dashboardSettings.interviews"
                        :multiple="true"
                        :isRequired="true"
                        @securityRolesChange="(newValue) => this.dashboardSettings.interviews = newValue"
                      ></SecurityRolesDropDownList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ml-3">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="2" xl="1">
                      <v-card-text class="py-0 px-0">LER</v-card-text>
                    </v-col>
                    <v-col col="12" sm="9" md="8" lg="6" xl="3" class="py-0">
                      <SecurityRolesDropDownList
                        :securityRoles="dashboardSettings.ler"
                        :multiple="true"
                        :isRequired="true"
                        @securityRolesChange="(newValue) => this.dashboardSettings.ler = newValue"
                      ></SecurityRolesDropDownList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ml-3">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="2" xl="1">
                      <v-card-text class="py-0 px-0">NTS</v-card-text>
                    </v-col>
                    <v-col col="12" sm="9" md="8" lg="6" xl="3" class="py-0">
                      <SecurityRolesDropDownList
                        :securityRoles="dashboardSettings.nts"
                        :multiple="true"
                        :isRequired="true"
                        @securityRolesChange="(newValue) => this.dashboardSettings.nts = newValue"
                      ></SecurityRolesDropDownList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ml-3">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="2" xl="1">
                      <v-card-text class="py-0 px-0">NTS by Employee</v-card-text>
                    </v-col>
                    <v-col col="12" sm="9" md="8" lg="6" xl="3" class="py-0">
                      <SecurityRolesDropDownList
                        :securityRoles="dashboardSettings.ntsByEmployee"
                        :multiple="true"
                        :isRequired="true"
                        @securityRolesChange="(newValue) => this.dashboardSettings.ntsByEmployee = newValue"
                      ></SecurityRolesDropDownList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ml-3">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="2" xl="1">
                      <v-card-text class="py-0 px-0">Perm. Placement Goal</v-card-text>
                    </v-col>
                    <v-col col="12" sm="9" md="8" lg="6" xl="3" class="py-0">
                      <SecurityRolesDropDownList
                        :securityRoles="dashboardSettings.permPlacementGoal"
                        :multiple="true"
                        :isRequired="true"
                        @securityRolesChange="(newValue) => this.dashboardSettings.permPlacementGoal = newValue"
                      ></SecurityRolesDropDownList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ml-3">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="2" xl="1">
                      <v-card-text class="py-0 px-0">Placement Goal</v-card-text>
                    </v-col>
                    <v-col col="12" sm="9" md="8" lg="6" xl="3" class="py-0">
                      <SecurityRolesDropDownList
                        :securityRoles="dashboardSettings.placementGoal"
                        :multiple="true"
                        :isRequired="true"
                        @securityRolesChange="(newValue) => this.dashboardSettings.placementGoal = newValue"
                      ></SecurityRolesDropDownList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ml-3">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="2" xl="1">
                      <v-card-text class="py-0 px-0">Revenue</v-card-text>
                    </v-col>
                    <v-col col="12" sm="9" md="8" lg="6" xl="3" class="py-0">
                      <SecurityRolesDropDownList
                        :securityRoles="dashboardSettings.revenue"
                        :multiple="true"
                        :isRequired="true"
                        @securityRolesChange="(newValue) => this.dashboardSettings.revenue = newValue"
                      ></SecurityRolesDropDownList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ml-3" v-if="zohoIntegrationSettings.integrationEnabled">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" lg="2" xl="1">
                      <v-card-text class="py-0 px-0">Submissions</v-card-text>
                    </v-col>
                    <v-col col="12" sm="9" md="8" lg="6" xl="3" class="py-0">
                      <SecurityRolesDropDownList
                        :securityRoles="dashboardSettings.submissions"
                        :multiple="true"
                        :isRequired="true"
                        @securityRolesChange="(newValue) => this.dashboardSettings.submissions = newValue"
                      ></SecurityRolesDropDownList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :key="DEALS" class="ml-md-10" style="max-height: 650px; min-height: 650px; overflow: auto; overflow-x: hidden;">
              <v-row class="mt-3">
                <v-col cols="12" md="12" lg="9" xl="6">
                  <EmailRecipientCollector
                    label="Send All Deals Notification Recipients"
                    :show-notes="false"
                    :readonly="false"
                    :disabled="false"
                    :recipients-list="carbonCopyDealNotificationRecipients"
                    @nameChange="(id, newValue) => this.carbonCopyDealNotificationRecipients[id]['name'] = newValue"
                    @emailChange="(id, newValue) => this.carbonCopyDealNotificationRecipients[id]['emailAddress'] = newValue"
                    @deleteRecipient="(id) => this.carbonCopyDealNotificationRecipients.splice(id, 1)"
                    @addRecipient="() => this.carbonCopyDealNotificationRecipients.push({name: '', emailAddress: ''})"
                  ></EmailRecipientCollector>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" lg="9" xl="6">
                  <EmailRecipientCollector
                    label="New Deals Recipients"
                    :show-notes="false"
                    :readonly="false"
                    :disabled="false"
                    :recipients-list="newDealNotificationRecipients"
                    @nameChange="(id, newValue) => this.newDealNotificationRecipients[id]['name'] = newValue"
                    @emailChange="(id, newValue) => this.newDealNotificationRecipients[id]['emailAddress'] = newValue"
                    @deleteRecipient="(id) => this.newDealNotificationRecipients.splice(id, 1)"
                    @addRecipient="() => this.newDealNotificationRecipients.push({name: '', emailAddress: ''})"
                  ></EmailRecipientCollector>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" lg="9" xl="6">
                  <EmailRecipientCollector
                    label="Approved Deals Recipients"
                    :show-notes="false"
                    :readonly="false"
                    :disabled="false"
                    :recipients-list="approvedDealNotificationRecipients"
                    @nameChange="(id, newValue) => this.approvedDealNotificationRecipients[id]['name'] = newValue"
                    @emailChange="(id, newValue) => this.approvedDealNotificationRecipients[id]['emailAddress'] = newValue"
                    @deleteRecipient="(id) => this.approvedDealNotificationRecipients.splice(id, 1)"
                    @addRecipient="() => this.approvedDealNotificationRecipients.push({name: '', emailAddress: ''})"
                  ></EmailRecipientCollector>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" lg="9" xl="6">
                  <EmailRecipientCollector
                    label="Rejected Deals Recipients"
                    :show-notes="false"
                    :readonly="false"
                    :disabled="false"
                    :recipients-list="rejectedDealNotificationRecipients"
                    @nameChange="(id, newValue) => this.rejectedDealNotificationRecipients[id]['name'] = newValue"
                    @emailChange="(id, newValue) => this.rejectedDealNotificationRecipients[id]['emailAddress'] = newValue"
                    @deleteRecipient="(id) => this.rejectedDealNotificationRecipients.splice(id, 1)"
                    @addRecipient="() => this.rejectedDealNotificationRecipients.push({name: '', emailAddress: ''})">
                  </EmailRecipientCollector>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :key="EMAIL_SERVER" class="ml-md-10" style="max-height: 650px; min-height: 650px; overflow: auto; overflow-x: hidden;">
              <v-row class="mt-3">
                <v-col cols="12" md="6" lg="5" xl="4">
                  <v-text-field
                    label="Email Server"
                    v-model="emailSettings.serverHost"
                    clearable
                    outlined
                    validate-on-blur
                    :rules="[required('Email Server')]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" lg="5" xl="4">
                  <v-text-field
                    label="Server Port"
                    v-model="emailSettings.serverPort"
                    clearable
                    outlined
                    validate-on-blur
                    :rules="[required('Server Port')]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" lg="5" xl="4">
                  <v-text-field
                    label="User Email"
                    v-model="emailSettings.userEmail"
                    clearable
                    outlined
                    validate-on-blur
                    :rules="[required('User Email')]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" lg="5" xl="4">
                  <PasswordField
                    label="User Password"
                    :value="emailSettings.passwordAuthentication"
                    :is-required="true"
                    :is-needed-to-validate="false"
                    @valueChange="(newValue) => this.emailSettings.passwordAuthentication = newValue"
                  ></PasswordField>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" lg="5" xl="4" class="pt-0">
                  <v-checkbox
                    v-model="emailSettings.sslRequired"
                    label="SSL Required">
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :key="HEADCOUNT" class="ml-md-10" style="max-height: 650px; min-height: 650px; overflow: auto; overflow-x: hidden;">
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-card-title class="py-0 px-0">High Billers</v-card-title>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="4" lg="3" xl="2">
                  <FormattedNumberField
                    label="Bill Rate >="
                    :value="headCountSettings.highBillersStartingAt"
                    :required="true"
                    prepend-inner-icon="attach_money"
                    @valueChange="(newValue) => this.headCountSettings.highBillersStartingAt = newValue"
                  ></FormattedNumberField>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :key="PAY_RATE" class="ml-md-10" style="max-height: 650px; min-height: 650px; overflow: auto; overflow-x: hidden;">
              <v-row class="mt-3">
                <v-col cols="12" sm="6" md="3" xl="2">
                  <v-row>
                    <v-col cols="12">
                      <v-card-title class="py-0 px-0">Overhead</v-card-title>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="10" lg="9">
                      <FormattedNumberField
                        label="1099"
                        :value="payRateSettings.overheadPercentage1099"
                        append-icon="percentage"
                        @valueChange="(newValue) => this.payRateSettings.overheadPercentage1099 = newValue"
                      ></FormattedNumberField>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="10" lg="9">
                      <FormattedNumberField
                        label="C2C"
                        :value="payRateSettings.overheadPercentageC2C"
                        append-icon="percentage"
                        @valueChange="(newValue) => this.payRateSettings.overheadPercentageC2C = newValue"
                      ></FormattedNumberField>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="10" lg="9">
                      <FormattedNumberField
                        label="W2 no Benefits"
                        :value="payRateSettings.overheadPercentageW2NoBenefits"
                        :validate-on-blur="true"
                        append-icon="percentage"
                        :rules="[Required('This Field')]"
                        @valueChange="(newValue) => this.payRateSettings.overheadPercentageW2NoBenefits = newValue"
                      ></FormattedNumberField>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="10" lg="9">
                      <FormattedNumberField
                        label="W2 + Benefits"
                        :value="payRateSettings.overheadPercentageW2Benefits"
                        :validate-on-blur="true"
                        append-icon="percentage"
                        :rules="[Required('This Field')]"
                        @valueChange="(newValue) => this.payRateSettings.overheadPercentageW2Benefits = newValue"
                      ></FormattedNumberField>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="3" xl="2">
                  <v-row>
                    <v-col cols="12">
                      <v-card-title class="py-0 px-0">Hours Worked Monthly Default</v-card-title>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="10" lg="9">
                      <FormattedNumberField
                        label="Hours"
                        :value="payRateSettings.workedHoursAverageDefault"
                        :validate-on-blur="true"
                        :rules="[Required('This Field')]"
                        @valueChange="(newValue) => this.payRateSettings.workedHoursAverageDefault = newValue"
                      ></FormattedNumberField>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-card-title class="py-0 px-0">Overtime</v-card-title>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="10" lg="9">
                      <FormattedNumberField
                        label="Default Threshold"
                        :value="payRateSettings.overtimeThresholdDefault"
                        :validate-on-blur="true"
                        :rules="[Required('This Field')]"
                        @valueChange="(newValue) => this.payRateSettings.overtimeThresholdDefault = newValue"
                      ></FormattedNumberField>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="10" lg="9">
                      <FormattedNumberField
                        label="Default Rate"
                        :value="payRateSettings.overtimeRateDefault"
                        :validate-on-blur="true"
                        :rules="[Required('This Field')]"
                        @valueChange="(newValue) => this.payRateSettings.overtimeRateDefault = newValue"
                      ></FormattedNumberField>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :key="SCHEDULED_JOBS" class="ml-md-10" style="max-height: 650px; min-height: 650px; overflow: auto; overflow-x: hidden;">
              <v-card-title class="py-md-0 px-0">
                Contract with Upcoming End Dates
                <v-switch
                  v-model="scheduledJobsSettings.assignmentsAboutToEnd.isActive"
                  label="Active"
                  class="ml-10"
                ></v-switch>
              </v-card-title>
              <v-divider></v-divider>
              <v-row class="mt-3 pl-md-10">
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <FormattedNumberField
                    label="Include Contracts Ending Within XX Days"
                    :value="scheduledJobsSettings.assignmentsAboutToEnd.daysToNotificate"
                    :onlyInt="true"
                    :required="true"
                    :disabled="!scheduledJobsSettings.assignmentsAboutToEnd.isActive"
                    @valueChange="(newValue) => this.scheduledJobsSettings.assignmentsAboutToEnd.daysToNotificate = newValue"
                    ></FormattedNumberField>
                  </v-col>
                  <v-col cols="12" sm="6" lg="3" xl="2">
                    <WeekdayPicker
                      label="Execute Job on Every"
                      :daysOptions="[SUNDAY, MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY]"
                      :day="scheduledJobsSettings.assignmentsAboutToEnd.executeOnEvery"
                      :disabled="!scheduledJobsSettings.assignmentsAboutToEnd.isActive"
                      @dayChange="(newValue) => this.scheduledJobsSettings.assignmentsAboutToEnd.executeOnEvery = newValue"
                    ></WeekdayPicker>
                  </v-col>
                <v-col cols="12" sm="6" lg="3" xl="2">
                  <TimePicker
                    label="Execute At"
                    :required="true"
                    :value="this.scheduledJobsSettings.assignmentsAboutToEnd.executeAt"
                    :disabled="!scheduledJobsSettings.assignmentsAboutToEnd.isActive"
                    @valueChange="(newValue) => this.scheduledJobsSettings.assignmentsAboutToEnd.executeAt = newValue"
                  ></TimePicker>
                </v-col>
              </v-row>
              <v-row class="pl-md-10">
                <v-col cols="12" md="12" lg="9" xl="6">
                  <EmailRecipientCollector
                    :show-notes="false"
                    :readonly="false"
                    :disabled="!scheduledJobsSettings.assignmentsAboutToEnd.isActive"
                    :recipients-list="scheduledJobsSettings.assignmentsAboutToEnd.recipients"
                    @nameChange="(id, newValue) => this.scheduledJobsSettings.assignmentsAboutToEnd.recipients[id]['name'] = newValue"
                    @emailChange="(id, newValue) => this.scheduledJobsSettings.assignmentsAboutToEnd.recipients[id]['emailAddress'] = newValue"
                    @deleteRecipient="(id) => this.scheduledJobsSettings.assignmentsAboutToEnd.recipients.splice(id, 1)"
                    @addRecipient="() => this.scheduledJobsSettings.assignmentsAboutToEnd.recipients.push({name: '', emailAddress: ''})"
                    ></EmailRecipientCollector>
                </v-col>
              </v-row>
              <v-card-title class="mt-5 py-0 px-0">
                Time Sheet - No Entered Time Notification
                <v-switch
                  v-model="scheduledJobsSettings.timeSheetNoTimeEnteredNotification.isActive"
                  label="Active"
                  class="ml-10"
                ></v-switch>
              </v-card-title>
              <v-divider></v-divider>
              <v-row class="mt-3 pl-md-10">
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <FormattedNumberField
                    label="After XX Days of not Entering Time"
                    :value="scheduledJobsSettings.timeSheetNoTimeEnteredNotification.daysToNotificate"
                    :onlyInt="true"
                    :required="true"
                    :disabled="!scheduledJobsSettings.timeSheetNoTimeEnteredNotification.isActive"
                    @valueChange="(newValue) => this.scheduledJobsSettings.timeSheetNoTimeEnteredNotification.daysToNotificate = newValue"
                    ></FormattedNumberField>
                  </v-col>
                  <v-col cols="12" sm="6" lg="3" xl="2">
                    <WeekdayPicker
                      label="Execute Job on Every"
                      :daysOptions="[SUNDAY, MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY]"
                      :day="scheduledJobsSettings.timeSheetNoTimeEnteredNotification.executeOnEvery"
                      :disabled="!scheduledJobsSettings.timeSheetNoTimeEnteredNotification.isActive"
                      @dayChange="(newValue) => this.scheduledJobsSettings.timeSheetNoTimeEnteredNotification.executeOnEvery = newValue"
                    ></WeekdayPicker>
                  </v-col>
                <v-col cols="12" sm="6" lg="3" xl="2">
                  <TimePicker
                    label="Execute At"
                    :required="true"
                    :value="this.scheduledJobsSettings.timeSheetNoTimeEnteredNotification.executeAt"
                    :disabled="!scheduledJobsSettings.timeSheetNoTimeEnteredNotification.isActive"
                    @valueChange="(newValue) => this.scheduledJobsSettings.timeSheetNoTimeEnteredNotification.executeAt = newValue"
                  ></TimePicker>
                </v-col>
              </v-row>
              <v-row class="pl-md-10">
                <v-col cols="12" md="12" lg="9" xl="6">
                  <EmailRecipientCollector
                    :show-notes="false"
                    :readonly="false"
                    :disabled="!scheduledJobsSettings.timeSheetNoTimeEnteredNotification.isActive"
                    :recipients-list="scheduledJobsSettings.timeSheetNoTimeEnteredNotification.recipients"
                    @nameChange="(id, newValue) => this.scheduledJobsSettings.timeSheetNoTimeEnteredNotification.recipients[id]['name'] = newValue"
                    @emailChange="(id, newValue) => this.scheduledJobsSettings.timeSheetNoTimeEnteredNotification.recipients[id]['emailAddress'] = newValue"
                    @deleteRecipient="(id) => this.scheduledJobsSettings.timeSheetNoTimeEnteredNotification.recipients.splice(id, 1)"
                    @addRecipient="() => this.scheduledJobsSettings.timeSheetNoTimeEnteredNotification.recipients.push({name: '', emailAddress: ''})"
                    ></EmailRecipientCollector>
                </v-col>
              </v-row>
              <v-card-title class="mt-5 py-0 px-0">
                Time Sheet - Reminder (Consultants)
                <v-switch
                  v-model="scheduledJobsSettings.timeSheetNoTimeEnteredReminder.isActive"
                  label="Active"
                  class="ml-10"
                ></v-switch>
              </v-card-title>
              <v-divider></v-divider>
              <v-row class="mt-3 pl-md-10">
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <FormattedNumberField
                    label="After XX Days of not Entering Time"
                    :value="scheduledJobsSettings.timeSheetNoTimeEnteredReminder.daysToNotificate"
                    :onlyInt="true"
                    :required="true"
                    :disabled="!scheduledJobsSettings.timeSheetNoTimeEnteredReminder.isActive"
                    @valueChange="(newValue) => this.scheduledJobsSettings.timeSheetNoTimeEnteredReminder.daysToNotificate = newValue"
                    ></FormattedNumberField>
                  </v-col>
                  <v-col cols="12" sm="6" lg="3" xl="2">
                    <WeekdayPicker
                      label="Execute Job on Every"
                      :daysOptions="[SUNDAY, MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY]"
                      :day="scheduledJobsSettings.timeSheetNoTimeEnteredReminder.executeOnEvery"
                      :disabled="!scheduledJobsSettings.timeSheetNoTimeEnteredReminder.isActive"
                      @dayChange="(newValue) => this.scheduledJobsSettings.timeSheetNoTimeEnteredReminder.executeOnEvery = newValue"
                    ></WeekdayPicker>
                  </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" xl="2">
                  <TimePicker
                    label="Execute At"
                    :required="true"
                    :value="this.scheduledJobsSettings.timeSheetNoTimeEnteredReminder.executeAt"
                    :disabled="!scheduledJobsSettings.timeSheetNoTimeEnteredReminder.isActive"
                    @valueChange="(newValue) => this.scheduledJobsSettings.timeSheetNoTimeEnteredReminder.executeAt = newValue"
                  ></TimePicker>
                </v-col>
                <v-col cols="12" md="9" lg="5">
                  <EmailInput
                    :label="'Contact E-Mail'"
                    :email-address="scheduledJobsSettings.timeSheetNoTimeEnteredReminder.contactEmail"
                    :is-required="scheduledJobsSettings.timeSheetNoTimeEnteredReminder.isActive"
                    :disabled="!scheduledJobsSettings.timeSheetNoTimeEnteredReminder.isActive"
                    @emailChange="(newValue) => this.scheduledJobsSettings.timeSheetNoTimeEnteredReminder.contactEmail = newValue">
                  </EmailInput>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :key="SYSTEM" class="ml-md-10" style="max-height: 650px; min-height: 650px; overflow: auto; overflow-x: hidden;">
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-card-title class="py-0 px-0">First Day of The Week</v-card-title>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="3" lg="2" xl="1">
                  <WeekdayPicker
                    :daysOptions="[SUNDAY, MONDAY]"
                    :day="beginningOfWeek"
                    @dayChange="(newValue) => this.beginningOfWeek = newValue"
                  ></WeekdayPicker>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-card-title class="py-0 px-0">Biweekly Periods</v-card-title>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" md="3" lg="2" xl="1" class="pb-0">
                  <v-form ref="biweeklyPeriods">
                    <v-text-field
                      label="Year"
                      v-model="biweeklyPeriodsYear"
                      validate-on-blur
                      outlined
                      :maxlength="4"
                      :rules="[required('Year')]"
                    ></v-text-field>
                  </v-form>
                </v-col>
                <v-col cols="4" md="3" lg="2" xl="1" class="pb-0">
                  <v-btn
                    outlined
                    color="primary"
                    block
                    @click="searchBiweeklyPeriods"
                  >
                    Search
                  </v-btn>
                </v-col>
                <v-col cols="4" md="3" lg="2" xl="1" class="pb-0">
                  <v-btn
                    outlined
                    color="primary"
                    block
                    @click="importBiweeklyPeriods"
                  >
                    Import
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="9" lg="6" xl="3" class="pt-0">
                  <v-data-table
                    dense
                    :headers="biweeklyPeriodsHeaders"
                    :items="biweeklyPeriodsList"
                    :items-per-page="5"
                  >
                    <template v-slot:item.dateBegin="{ item }">
                      {{ formatFileDate(item.dateBegin) }}
                    </template>
                    <template v-slot:item.dateEnd="{ item }">
                      {{ formatFileDate(item.dateEnd) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item :key="ZOHO_INTEGRATION" class="ml-md-10" style="max-height: 650px; min-height: 650px; overflow: auto; overflow-x: hidden;">
              <v-card-title class="mt-5 py-0 px-0">
                Zoho Integration
                <v-switch
                  v-model="zohoIntegrationSettings.integrationEnabled"
                  label="Active"
                  class="ml-10"
                  @change="zohoIntegrationEnabledChangeHandler"
                ></v-switch>
              </v-card-title>
              <v-divider></v-divider>
              <v-row class="mt-3 pl-md-10">
                <v-col cols="12" md="6" lg="5" xl="4">
                  <v-text-field
                    label="Client Id"
                    v-model="zohoIntegrationSettings.zohoClientId"
                    clearable
                    outlined
                    :disabled="!zohoIntegrationSettings.integrationEnabled"
                    validate-on-blur
                    :rules="[zohoIntegrationFieldsRequired]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="pl-md-10">
                <v-col cols="12" md="6" lg="5" xl="4">
                  <v-text-field
                    label="Client Secret"
                    v-model="zohoIntegrationSettings.zohoClientSecret"
                    clearable
                    outlined
                    :disabled="!zohoIntegrationSettings.integrationEnabled"
                    validate-on-blur
                    :rules="[zohoIntegrationFieldsRequired]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="pl-md-10">
                <v-col cols="12" md="6" lg="5" xl="4">
                  <v-text-field
                    label="Access Token"
                    v-model="zohoIntegrationSettings.zohoAccessToken"
                    clearable
                    outlined
                    :disabled="!zohoIntegrationSettings.integrationEnabled"
                    validate-on-blur
                    :rules="[zohoIntegrationFieldsRequired]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="pl-md-10">
                <v-col cols="12" md="6" lg="5" xl="4">
                  <v-text-field
                    label="Refresh Token"
                    v-model="zohoIntegrationSettings.zohoRefreshToken"
                    clearable
                    outlined
                    :disabled="!zohoIntegrationSettings.integrationEnabled"
                    validate-on-blur
                    :rules="[zohoIntegrationFieldsRequired]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
      <ButtonsSubmitForm
        :isFormValid="isFormValid"
        @save="save"
        @cancel="cancel"
      >
      </ButtonsSubmitForm>
    </v-form>
    <BiweeklyPeriodsImportModal
      ref="biweeklyPeriodsImportModal"
      @periodsImported="periodsImportedHandler"
    ></BiweeklyPeriodsImportModal>
  </v-container>
</template>

<script>

import { SimplePageHeader } from '@/components/pageComponents'
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { SimpleDatePicker, WeekdayPicker, TimePicker } from '@/components/shared/datePickers'
import Required from '@/lib/formValidations/required'
import { ButtonsSubmitForm } from '@/components/buttons'
import { EmailRecipientCollector } from '@/components/emails'
import { SecurityRolesDropDownList } from '@/components/securityRoles'
import EmailInput from '@/components/emails/EmailInput'
import { FormattedNumberField, PasswordField } from '@/components/shared/textFields'
import { dashboardRoute } from '@/lib/constants/routes'
import { SUNDAY, MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY } from '@/lib/constants/weekdays'
import BiweeklyPeriodsImportModal from '@/components/settings/BiweeklyPeriodsImportModal'
import { required } from '@/lib/formValidations'

export default {
  components: {
    EmailInput,
    SimplePageHeader,
    WeekdayPicker,
    SimpleDatePicker,
    ButtonsSubmitForm,
    EmailRecipientCollector,
    SecurityRolesDropDownList,
    FormattedNumberField,
    BiweeklyPeriodsImportModal,
    TimePicker,
    PasswordField
  },
  data () {
    return {
      isFormValid: false,
      tab: 0,
      DASHBOARD: 0,
      DEALS: 1,
      EMAIL_SERVER: 2,
      HEADCOUNT: 3,
      PAY_RATE: 4,
      SCHEDULED_JOBS: 5,
      SYSTEM: 6,
      ZOHO_INTEGRATION: 7,
      SUNDAY,
      MONDAY,
      TUESDAY,
      WEDNESDAY,
      THURSDAY,
      FRIDAY,
      SATURDAY,
      fileInput: null,
      biweeklyPeriodsYear: new Date().getFullYear(),
      biweeklyPeriodsHeaders: [
        { text: 'Period', value: 'period', align: 'center', width: '20%', sortable: false },
        { text: 'Date Begin', value: 'dateBegin', align: 'center', width: '40%', sortable: false },
        { text: 'Date End', value: 'dateEnd', align: 'center', width: '40%', sortable: false }
      ]
    }
  },
  computed: {
    ...mapFields('settings', [
      'dashboardSettings',
      'newDealNotificationRecipients',
      'approvedDealNotificationRecipients',
      'rejectedDealNotificationRecipients',
      'carbonCopyDealNotificationRecipients',
      'headCountSettings',
      'payRateSettings',
      'zohoIntegrationSettings',
      'beginningOfWeek',
      'scheduledJobsSettings',
      'emailSettings'
    ]),
    ...mapFields('biweeklyPeriods', [
      'biweeklyPeriodsList'
    ]),
    isSmallDisplay () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    required,
    ...mapActions('settings', [
      'getSettings',
      'updateSettings'
    ]),
    ...mapActions('biweeklyPeriods', [
      'getBiweeklyPeriods'
    ]),
    Required,
    save () {
      if (this.$refs.SettingsForm.validate()) {
        this.updateSettings().then(() => {
          this.$router.push(dashboardRoute)
        })
      }
    },
    cancel () {
      this.$router.push(dashboardRoute)
    },
    searchBiweeklyPeriods () {
      if (this.$refs.biweeklyPeriods.validate()) {
        this.getBiweeklyPeriods(this.biweeklyPeriodsYear)
      }
    },
    importBiweeklyPeriods () {
      this.$refs.biweeklyPeriodsImportModal.showModal(this.biweeklyPeriodsYear)
    },
    periodsImportedHandler (periods, year) {
      this.biweeklyPeriodsList = periods
      this.biweeklyPeriodsYear = year
    },
    formatFileDate (date) {
      return new Date(date).toLocaleDateString('en-US')
    },
    zohoIntegrationFieldsRequired (value) {
      if (this.zohoIntegrationSettings.integrationEnabled) {
        if (!value) {
          return 'This field is required'
        }
      }
      return true
    },
    zohoIntegrationEnabledChangeHandler (newValue) {
      this.$refs.SettingsForm.resetValidation()
      if (!newValue) {
        this.dashboardSettings.interviews = []
        this.dashboardSettings.submissions = []
      }
    }
  },
  mounted () {
    this.getSettings().then(() => {
      this.getBiweeklyPeriods()
    })
  }
}
</script>
